module.exports = __webpack_public_path__ + "static/z_tall_carrots-20cc70a9d0fae820d91142f4f468c8e6.jpg";